import type { Object3D } from 'three';

import type { SceneDiffManager } from '../scene-diff-manager.class';
import { createObjectSnapshot } from '../helpers/create-object-snapshot.helper';

export interface SnapshotSceneParams {
	objectHolder: Object3D;
}

/**
 * Capture current scene state
 */
export const snapshotSceneCfn = (self: SceneDiffManager, params: SnapshotSceneParams): void => {
	const { objectHolder } = params;
	const currentSnapshot = self.internalCurrentSnapshot;

	currentSnapshot.clear();

	objectHolder.traverse((child) => {
		// Skip the holder itself and objects without userData.id
		if (child === objectHolder || !child.userData?.id) {
			return;
		}

		const snapshot = createObjectSnapshot(child);
		if (snapshot) {
			if (currentSnapshot.has(snapshot.id)) {
				// Two Object3Ds share one domain id. This Map holds one entry per id,
				// so the other becomes a ghost: invisible to every later diff, and
				// therefore impossible to move or remove until a full recompose.
				// Nothing should reach this — say so rather than absorb it silently.
				console.warn(`SceneDiffManager: duplicate scene object id "${snapshot.id}" (${snapshot.type}) — one copy is now unreachable by the diff pipeline`);
			}
			currentSnapshot.set(snapshot.id, snapshot);
		}
	});
};
